import { useMutation } from "@tanstack/react-query";
import { client } from "./client";

export const useSignup = () => {
    return useMutation({
        mutationFn: async (payload) => {
            try {
                const response = await client("auth/register", {
                    method: "POST",
                    data: payload,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return response;
            } catch (error) {
                const errorResponse = {
                    message: error.message || "An error occurred during signup",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useLogin = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const response = await client("auth/login", {
                method: "POST",
                data: payload,
            });

            if (response.accessToken) {
                localStorage.setItem("accessToken", response.accessToken);
                localStorage.setItem("refreshToken", response.refreshToken);
                localStorage.setItem(
                    "accessTokenExpiryTs",
                    response.accessTokenExpiryTs
                );
            }
            return response;
        },
    });
};

export const useVerify = () => {
    return useMutation({
        mutationFn: async (payload) => {
            try {
                const response = await client("auth/verify", {
                    method: "POST",
                    data: payload,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return response;
            } catch (error) {
                const errorResponse = {
                    message:
                        error.message ||
                        "An error occurred during verification",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useResendOtp = () => {
    return useMutation({
        mutationFn: async (payload) => {
            try {
                const endpoint = `auth/resend-otp?email=${encodeURIComponent(
                    payload.email
                )}`;
                const response = await client(endpoint, {
                    method: "POST",
                });
                return response;
            } catch (error) {
                const errorResponse = {
                    message:
                        error.message ||
                        "An error occurred while resending OTP",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useRequestOtp = () => {
    return useMutation({
        mutationFn: async (payload) => {
            try {
                const response = await client(
                    "auth/forgot-password/request-otp",
                    {
                        method: "POST",
                        data: payload,
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                return response;
            } catch (error) {
                const errorResponse = {
                    message:
                        error.message ||
                        "An error occurred while requesting OTP",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useForgotPasswordReset = () => {
    return useMutation({
        mutationFn: async (payload) => {
            try {
                const response = await client("auth/forgot-password/reset", {
                    method: "POST",
                    data: payload,
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                return response;
            } catch (error) {
                const errorResponse = {
                    message:
                        error.message ||
                        "An error occurred while resetting password",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useResendForgotPasswordOtp = () => {
    return useMutation({
        mutationFn: async ({ email }) => {
            try {
                const response = await client(
                    "auth/resend-forgot-password-otp",
                    {
                        method: "POST",
                        data: { email },
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                return response;
            } catch (error) {
                const errorResponse = {
                    message:
                        error.message ||
                        "An error occurred while resetting password",
                    status: error.status || 500,
                    errors: error.errors || {},
                };
                throw errorResponse;
            }
        },
    });
};

export const useLogout = () => {
    return useMutation({
        mutationFn: async () => {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("accessTokenExpiryTs");
            localStorage.removeItem("refreshToken");
            window.location.reload();
            return { success: true };
        },
    });
};
